import { Link, useLocation } from "react-router-dom";
import AuthButton from "./AuthButton";
import TrialIndicator from "../TrialIndicator";
import type { TrialStatus } from "../../services/api-client";

interface HeaderProps {
  trialStatus?: TrialStatus | null;
}

export default function Header({ trialStatus = null }: HeaderProps) {
  const location = useLocation();
  const pathname = location.pathname;

  const navLinkClasses = (href: string) => {
    const isActive = pathname === href;
    return `
      font-emphasis text-[clamp(14px,2vw,18px)] xl:text-[clamp(13px,1vw,16px)] font-semibold uppercase-tracked
      text-muted-foreground hover:text-foreground
      px-2 py-2 border-b-[3px] transition-all duration-200
      ${isActive
        ? "text-foreground border-foreground"
        : "border-transparent hover:text-foreground"
      }
    `;
  };

  return (
    <>
      {/* Desktop Header */}
      <header className="hidden md:block sticky top-0 z-50 bg-surface border-b border-border">
        <div className="w-[90%] max-w-[1200px] mx-auto h-[clamp(56px,8vw,72px)] xl:h-[clamp(48px,4vw,60px)] flex items-center justify-between">
          {/* Logo - light version for light mode, dark version for dark mode */}
          <Link to="/" className="flex items-center">
            <img
              src="/logos/is-games-logo.svg"
              alt="IS Games"
              className="h-[clamp(32px,5vw,44px)] xl:h-[clamp(28px,2.5vw,38px)] dark:hidden"
            />
            <img
              src="/logos/is-games-logo-dark.svg"
              alt="IS Games"
              className="h-[clamp(32px,5vw,44px)] xl:h-[clamp(28px,2.5vw,38px)] hidden dark:block"
            />
          </Link>

          {/* Right side: Navigation + User Actions */}
          <div className="flex items-center gap-[clamp(16px,3vw,32px)] xl:gap-[clamp(14px,1.5vw,24px)]">
            {/* Desktop Navigation */}
            <nav className="flex gap-[clamp(24px,4vw,48px)] xl:gap-[clamp(20px,2.5vw,36px)]">
              <Link to="/" className={navLinkClasses("/")}>
                Games
              </Link>
              <Link to="/friends" className={navLinkClasses("/friends")}>
                Friends
              </Link>
            </nav>

            {/* User Actions */}
            <div className="flex items-center gap-3">
              <TrialIndicator status={trialStatus} />
              <AuthButton />
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Header */}
      <header className="md:hidden sticky top-0 z-50 bg-surface border-b border-border">
        <div className="px-[clamp(12px,3vw,16px)] py-[clamp(8px,2vw,14px)]">
          <div className="flex items-center justify-between">
            {/* Mobile Logo - light version for light mode, dark version for dark mode */}
            <Link to="/" className="flex items-center">
              <img
                src="/logos/is-games-logo.svg"
                alt="IS Games"
                className="h-[clamp(24px,6vw,32px)] dark:hidden"
              />
              <img
                src="/logos/is-games-logo-dark.svg"
                alt="IS Games"
                className="h-[clamp(24px,6vw,32px)] hidden dark:block"
              />
            </Link>

            {/* User Avatar */}
            <AuthButton isMobile />
          </div>
        </div>
      </header>
    </>
  );
}